import React from 'react';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import styled from 'styled-components'

const Card_ = styled(Card)`
  display: flex;
  width: 200px;
  height: 80px;
  padding: 10px;
  box-sizing: border-box;
  margin: 3px;
  cursor: pointer;
`

const CardMedia_ = styled(CardMedia)`
&& {
  flex: auto;
  background-size: contain;
}
`

function Logo(props) {
  return (
    <Card_ {...props}>
      <CardMedia_
        image={`${process.env.PUBLIC_URL}/img/logo.png`}
        title="Wilson Contabilidade"
      />
    </Card_>
  );
}

export default Logo;
